<template>
  <div class="cron-box">
    <Tabs size="small" type="card" v-model="activeName">
      <Tab-pane label="秒" name="s">
        <Time @time="second" lable="秒"></Time>
      </Tab-pane>
      <Tab-pane label="分" name="m">
        <Time @time="minute" lable="分"></Time>
      </Tab-pane>
      <Tab-pane label="时" name="h">
        <Time @time="hour" lable="时"></Time>
      </Tab-pane>
      <Tab-pane label="日(周)" name="d">
        <day @dayAndWeek="dayAndWeek" lable="日"></day>
      </Tab-pane>
      <Tab-pane label="月" name="month">
        <month @month="month" lable="月"></month>
      </Tab-pane>
      <Tab-pane label="年" name="year">
        <year @year="year" lable="年"></year>
      </Tab-pane>
    </Tabs>
  </div>
</template>

<script>
import Time from "./Time"
import day from "./day"
import month from "./month"
import year from "./year"
export default {
  components: {
    Time,
    day,
    month,
    year
  },
  data () {
    return {
      activeName: "s", // el-tab切换
      // 秒
      sVal: "0",
      // 分
      mVal: "0",
      // 时
      hVal: "0",
      // 日
      dVal: "*",
      // 月
      monthVal: "*",
      // 周
      weekVal: "?",
      // 年
      yearVal: " ",
      // 生成的完整cron表达式
      cronExpression: ""
    }
  },
  methods: {
    // 抛出的年份
    year (data) {
      this.yearVal = data
      this.createCron()
    },
    // 抛出的月份
    month (data) {
      this.monthVal = data
      this.createCron()
    },
    // 抛出的秒
    second (data) {
      this.sVal = data
      this.createCron()
    },
    // 抛出的分
    minute (data) {
      this.mVal = data
      this.createCron()
    },
    // 抛出的时
    hour (data) {
      this.hVal = data
      this.createCron()
    },
    // 抛出的周和日
    dayAndWeek (data) {
      console.log(data)
      this.dVal = data.day
      this.weekVal = data.week
      this.createCron()
    },
    // 生成表达式
    createCron () {
      this.cronExpression =
        this.sVal +
        " " +
        this.mVal +
        " " +
        this.hVal +
        " " +
        this.dVal +
        " " +
        this.monthVal +
        " " +
        this.weekVal +
        " " +
        this.yearVal
      this.$emit("change", this.cronExpression)
    }
  },
  created () {
    this.createCron()
  }
};
</script>

<style lang="css">
.cron-box .table-box {
  border-top: 1px solid #ebebeb;
  margin-top: 10px;
  padding-top: 10px;
  min-width: 400px;
}
.cron-box .Tabs .Tabs__header .Tabs__nav-prev {
  display: none;
}
.cron-box .Tabs .Tabs__header .Tabs__nav-next {
  display: none;
}
.cron-box .Tabs .Tabs__header .Tabs__nav-wrap {
  padding: 0 !important;
}
.cron-box .Tabs .Tabs__header .Tabs__nav-scroll {
  width: 400px !important;
}
.cron-box .Tabs .Tabs__header .Tabs__nav-scroll .Tabs__item:first-child {
  margin-left: -1px !important;
}
.cron-box .Tabs .Tabs__content {
  overflow-x: hidden;
  overflow-y: auto;
  height: 220px;
}
.cron-box .Tabs .Tabs__content::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
}
.cron-box .Tabs .Tabs__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #ebebeb;
}
.cron-box .Tabs .Tabs__content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: rgba(0, 0, 0, 0);
}
</style>
